import { Stack,createTheme, ThemeProvider, Divider } from "@mui/material";
import { Fragment } from "react";
import ReactDOM from 'react-dom/client';
import ENEAlogo from "./ENEAlogo";
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { blue, purple } from '@mui/material/colors';

import TableGare from "./TableLibraryGare";
import TableEsiti from "./TableLibraryEsiti";
import TableAvvisi from "./TableLibraryAvvisi";

import { definedAllegatiVals, TableAllegati} from "./TableLibraryAllegati";

//const root = ReactDOM.createRoot(document.getElementById("root"));
//root.render(<App />);
/*const theme = createTheme({
    palette: {
      primary: purple,
      secondary: lime,
      contrastThreshold: 4.5,
    },
  });*/

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    borderRadius:0,
    fontFamily:'Barlow',
    backgroundColor: blue[900],
    '&:hover': {
      backgroundColor: blue[600],
    },
  }));


// showlogo : true if show logo, false else
// name : name of table 
// head : header
// listnum : if table is 'allegati' the index of query 1 to 4
// mindate : string of from date of valid query format yyyy-mm-dd
// maxdate : string of to date of valid query format yyyy-mm-dd

const ENEATables = ({showlogo,name,head,listnum,mindate,maxdate})=>{
    
    let tabname = name; // #esito2415 -- #gara452
    let showid= '';
    if(window.location.hash!==''){
        const whash = window.location.hash.match(/#(?<tablename>[^\d]+)(?<showid>\d*)/).groups;
        showid = whash.showid;
        tabname = whash.tablename;
        /* remove filter if exists */
        if(showid.length>0){
            mindate=undefined;
            maxdate=undefined;
        }
    } 
    
    if(tabname.startsWith('allegati')){
        if(listnum===undefined){
            listnum=Number(tabname.substring(tabname.length-1));   
        }
        if(isNaN(listnum)){
            listnum=1;
        }
        if(listnum>definedAllegatiVals.length){
            listnum=1;
        }
        if(listnum<1){
            listnum=1;
        }
    }

    const viewlogo = ()=>{
        if(showlogo==='yes'){
            return(<ENEAlogo/>);
        }
        return (<></>);  
    };

    /*const dateregex = /\d{4}-\d{2}-\d{2}/;
    if(mindate!==undefined){
        const fromdate = new Date(mindate.match(dateregex));
    }
    if(maxdate!==undefined){
        const todate = new Date(maxdate); 
    }*/
   
   

    const selectedTitle = ()=>{
        if(typeof listnum === 'number'){
            return definedAllegatiVals[listnum-1].title;
        }
    }

    if(tabname==='avvisi'){
        return(
        <Fragment>
            <Stack direction='row' spacing={10} sx={{ alignItems: "center" }}>
                {viewlogo()}
                <h2>Elenco {tabname}</h2>
            </Stack>
            <TableAvvisi showid={showid} mindate={mindate} maxdate={maxdate}/>
        </Fragment>);
    }

    if(tabname==='esiti'){
        return(
        <Fragment>
            <Stack direction='row' spacing={10} sx={{ alignItems: "center" }}>
                {viewlogo()}
                {showid==='' && (<h2>Elenco {tabname}</h2>)}
                {showid!=='' && (<h2>Vista {tabname}</h2>)}
            </Stack>
            <TableEsiti showid={showid} mindate={mindate} maxdate={maxdate}/>
        </Fragment>);
    }

    if(tabname==='gare'){
        return(<Fragment>
            <Stack direction='row' spacing={10} sx={{ alignItems: "center" }}>
                {viewlogo()}
                {showid==='' && (<h2>Elenco {tabname}</h2>)}
                {showid!=='' && (<h2>Vista {tabname}</h2>)}
            </Stack>
            <TableGare showid={showid} mindate={mindate} maxdate={maxdate}/>
        </Fragment>)
    }

    if(tabname.startsWith("allegati")){
        return (<Fragment>
            <Stack direction='row' spacing={10} sx={{ alignItems: "center" }}>
                {viewlogo()}
                <h2>Elenco {selectedTitle()}</h2>
            </Stack>
            <TableAllegati listnum={listnum} mindate={mindate} maxdate={maxdate}/>       
        </Fragment>);
    }
    

    return(
        <Fragment>
            <Stack direction='row' spacing={10} sx={{ alignItems: "center" }}>
                {viewlogo()}
                <h2>Tabella {tabname} non esiste</h2>
            </Stack>
        </Fragment>
    );
}

export default ENEATables;
